import React from "react";
import { getDistance } from "../helperFunctions";

export default function Connector(props) {
  const { start, end, color } = props;
  const distance = React.useMemo(() => getDistance(start, end), [start, end]);
  const connectorRef = React.useRef(null);
  const geometryRef = React.useRef(null);
  React.useEffect(() => {
    connectorRef.current.lookAt(...end);
    geometryRef.current.translate(0, distance / 2, 0);
  }, [connectorRef, geometryRef, end, distance]);
  return (
    <group position={start} ref={connectorRef}>
      <mesh rotation={[Math.PI / 2, 0, 0]}>
        <cylinderBufferGeometry attach="geometry" args={[0.1, 0.1, distance, 16]} ref={geometryRef} />
        <meshStandardMaterial attach="material" color={color} />
      </mesh>
    </group>
  );
}
